<template>
  <v-container
    :class="{
      'no-max-width': fullWidth
    }"
  >
    <v-row>
      <v-col
        cols="12"
        xs="12"
        :lg="largeLayout ? 12 : 10"
        :offset-lg="largeLayout ? 0 : 1"
        class="text-xs-left"
      >
<!--        <breadcrumb-navigation />-->

        <v-toolbar
          flat
        >
          <v-toolbar-title>
            <span class="display-1 white--text font-weight-thin">{{ title }}</span>
            <slot name="title" />
          </v-toolbar-title>
          <v-spacer />
            <slot name="actionButton" />
        </v-toolbar>

        <v-divider class="my-3" />

        <slot name="main" />
      </v-col>
    </v-row>
  </v-container>
</template>
<style>
  .no-max-width {
    max-width: none !important;
  }
</style>
<script>
  import BreadcrumbNavigation from '@/components/Common/BreadcrumbNavigation.vue'

  export default {
    components: {
      BreadcrumbNavigation
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      largeLayout: {
        type: Boolean,
        default: false
      },
      fullWidth: {
        type: Boolean,
        default: false,
      }
    },
  }
</script>
